import { Links } from '_types/public-api';

export const getAttributes = (links: Links | undefined, pageId: string) => {
  const findRelation = links && links?.included.find((page) => page.id === pageId);
  return findRelation?.attributes;
};
